module.exports = __webpack_public_path__ + "6fbf236a48a6ee90e24d10672fd23580.pdf";